<template>
  <div
    class="panel-overlay design-system position-fixed w-100 h-100 top-0 left-0"
    :class="{ 'panel-overlay-on': isPanelOn, 'd-none': !isPanelOn }"
    @click.self="close()"
  >
    <div class="panel panel-right position-absolute h-100 top-0 right-0" :class="{ 'panel-on': isPanelOn }">
      <div class="panel-container w-100 h-100" :class="{ 'with-footer': $slots.footer }">
        <div class="panel-overflow-container h-100">
          <CxContainer padding="md">
            <CxRow class="panel-header mx-0">
              <CxCol alignItems="center" class="d-flex" noGutters col="11">
                <slot name="header">
                  <CxTitle level="2" fontWeight="normal" class="mb-0">{{ title }}</CxTitle>
                </slot>
              </CxCol>
              <CxCol alignItems="center" flexDirection="row-reverse" class="d-flex" noGutters col="1">
                <CxButton class="p-0" @click="close" variant="close"><CxIcon size="32" icon="close" /></CxButton>
              </CxCol>
            </CxRow>
            <CxRow class="panel-messages">
              <CxCol>
                <slot name="messages" class="panel-messages" />
              </CxCol>
            </CxRow>
            <CxRow marginTop="md">
              <CxCol>
                <hr class="w-100 m-0" />
              </CxCol>
            </CxRow>
            <CxRow class="panel-content">
              <CxCol>
                <slot />
              </CxCol>
            </CxRow>
          </CxContainer>
        </div>
        <CxContainer
          padding="md"
          class="panel-footer border-top position-absolute bottom-0 left-0"
          v-if="$slots.footer"
        >
          <slot name="footer" />
        </CxContainer>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { CxTitle } from "@/designSystem/Typography";
import { CxCol, CxContainer, CxRow } from "@/designSystem/Grid";
import { CxButton, CxIcon } from "@/designSystem";

defineProps({
  title: {
    type: String,
    required: true,
  },
});

const isPanelOn = ref(false);

const close = () => (isPanelOn.value = false);

const open = () => (isPanelOn.value = true);

const toggle = () => (isPanelOn.value = !isPanelOn.value);

defineExpose({ open, close, toggle });
</script>

<style lang="scss" scoped>
@import "@/designSystem/style/main.scss";
@import "@/designSystem/style/variables/_font.scss";
@import "@/designSystem/style/variables/_colors.scss";
@import "bootstrap/scss/mixins/breakpoints";

$zindex-panel-overlay: 1035 !default;
$width: 620px;
$width-tablet: 506px;
$overlay-bg-color: rgba(#000000, 0.1);
$footer-height: 5.75rem * $coef; // 24px * 2 + 44px = 92px;

.panel-overlay {
  background-color: $overlay-bg-color;
  z-index: $zindex-panel-overlay;
}

.panel-container.with-footer {
  padding-bottom: $footer-height;
}

.panel-overflow-container {
  overflow: auto;
}

.panel {
  width: $width;
  background-color: $white;
}

@include media-breakpoint-only(md) {
  .panel {
    width: $width-tablet;
  }
}

@include media-breakpoint-down(sm) {
  .panel {
    width: 100%;
  }
}
</style>
